import React from "react";
const AuthProvider = (props) => {
  const [auth, setAuth] = React.useState(props.auth);
  React.useEffect(() => {
    setAuth(props.auth);
  }, [props.auth]);
  const isPrivateCustomerRepresentingSelf = (currentAuth) => {
    const { dealer, customer, person } = currentAuth;
    if (!!dealer || !(customer == null ? void 0 : customer.customerId) || !person) {
      return false;
    }
    return customer.type === "B2C" && customer.registrationNumber === person.personalCode && customer.registrationNumberCountryCode === person.personalCodeCountryCode;
  };
  return /* @__PURE__ */ React.createElement(AuthContext.Provider, { value: { auth } }, !!auth && isPrivateCustomerRepresentingSelf(auth) ? props.children : null);
};
const AuthContext = React.createContext({
  auth: null
});
const useAuth = () => {
  return React.useContext(AuthContext);
};
export {
  AuthContext,
  AuthProvider,
  useAuth
};
